<template>
  <div class="video">
    <div class="wrap-video">
      <div class="videoHost">
        <div id="liveVideo"></div>
      </div>
      <div class="partisipant">
        <div id="participant"></div>
      </div>
    </div>
    <!-- <div class="error" v-else-if="status == 403">
      Link sudah kedaluarsa
    </div>
    <div class="error" v-else>
      Mohon tunggu sampai tanggal yang sudah dijadwalkan
    </div> -->
  </div>
</template>

<script>
import axios from "axios";
import Twilio from "twilio-video";
export default {
  data() {
    return {
      status: "",
    };
  },
  mounted() {
    let room_name = this.$route.params.id;
    let id = "Nasabah";
    axios
      .get("v1/user/video/" + room_name)
      .then((resp) => {
        if (resp.status == 200) {
          this.status = 200;
          axios.get("v1/get/twilio/access_token?identity=" + id).then((resp) => {
            let token = resp.data.data.token;

            Twilio.connect(token, { video: { width: 350 }, name: room_name, audio: true }).then((room) => {
              console.log(`Connected to Room: ${room}`);

              Twilio.createLocalVideoTrack().then((track) => {
                const localMediaContainer = document.getElementById("liveVideo");
                localMediaContainer.appendChild(track.attach());
              });

              // Attach the Participant's Media to a <div> element.
              room.on("participantConnected", (participant) => {
                console.log(`Participant "${participant.identity}" connected`);

                participant.tracks.forEach((publication) => {
                  if (publication.isSubscribed) {
                    const track = publication.track;
                    document.getElementById("participant").appendChild(track.attach());
                  }
                });

                participant.on("trackSubscribed", (track) => {
                  document.getElementById("participant").appendChild(track.attach());
                });
              });

              room.participants.forEach((participant) => {
                participant.tracks.forEach((publication) => {
                  if (publication.track) {
                    document.getElementById("participant").appendChild(publication.track.attach());
                  }
                });

                participant.on("trackSubscribed", (track) => {
                  document.getElementById("participant").appendChild(track.attach());
                });
              });
            });
          });
        }
      })
      .catch((error) => {
        this.status = error.response.status;
      });
  },
  // methods:{
  //   is
  // }
};
</script>

<style scoped>
.wrap-video {
  display: flex;
  justify-content: space-around;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.videoHost,
.partisipant {
  border: solid 1px #dddddd;
  width: 400px;
  height: 380px;
  margin: 10px;
  padding: 30px 22px;
}
</style>
